import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { selectAuthState } from '@app/auth/store/auth.reducers';
import { V1_AUTH_USER_ROLE } from '@app/models/api/v1/auth/auth.enums';
import { USER_MODULE } from '@app/shared/models/user-modules';

const isNotTerminal = (): (() => Observable<boolean | UrlTree>) => {
  return (): Observable<boolean | UrlTree> => {
    const store = inject(Store);
    const router = inject(Router);
    return store.select(selectAuthState).pipe(
      filter(state => state.user.initialAuthAttempt),
      take(1),
      map(state => {
        if (state?.user?.user?.roles.includes(V1_AUTH_USER_ROLE.TERMINAL)) {
          const bothTerminalVersionStored = state.terminal?.terminal?.uuid && state.terminalV2?.terminal?.uuid;
          const noTerminalVersionStored = !state.terminal?.terminal?.uuid && !state.terminalV2?.terminal?.uuid;

          if (bothTerminalVersionStored || noTerminalVersionStored) {
            const hasUserAttedanceV2Module = !!state.user.user.modules[USER_MODULE.ATTENDANCE_V2];
            return hasUserAttedanceV2Module ? router.createUrlTree(['/', 'terminal-v2']) : router.createUrlTree(['/', 'terminal']);
          }

          return state.terminal?.terminal?.uuid ? router.createUrlTree(['/', 'terminal']) : router.createUrlTree(['/', 'terminal-v2']);
        } else {
          return true;
        }
      }),
    );
  };
};

export const notTerminalCanActivateGuard: () => CanActivateFn = isNotTerminal;

export const notTerminalCanMatchGuard: () => CanMatchFn = isNotTerminal;
